import React from 'react';
import { NodeSubtype, NodeType, RING_LABELS } from '../../types';
import { ringAt } from '../../utils/geometry';
import { useSessionStore } from '../../store/sessionStore';
import NodeFormPopup from './NodeFormPopup';

interface NodeAddPopupProps {
  svgX: number;
  svgY: number;
  screenX: number;
  screenY: number;
  onClose: () => void;
}

const NodeAddPopup: React.FC<NodeAddPopupProps> = ({ svgX, svgY, screenX, screenY, onClose }) => {
  const addNode = useSessionStore(s => s.addNode);
  const ringScale = useSessionStore(s => s.ringScale);

  const ri = ringAt(svgX, svgY, ringScale);
  const zoneLabel = ri >= 0 ? `+ nodo en "${RING_LABELS[ri]}"` : '+ nodo externo';

  const defaultType: NodeType = ri >= 0 ? 'resource' : 'actor';
  const defaultSubtype: NodeSubtype = ri >= 0 ? 'tool' : 'external_party';

  const handleConfirm = (label: string, type: NodeType, subtype: NodeSubtype) => {
    const trimmedLabel = label.trim();

    if (!trimmedLabel) {
      onClose();
      return;
    }

    const forcedType: NodeType = ri >= 0 ? type : 'actor';
    const forcedSubtype: NodeSubtype = ri >= 0 ? subtype : 'external_party';

    addNode(trimmedLabel, svgX, svgY, forcedType, forcedSubtype);
    onClose();
  };

  return (
    <NodeFormPopup
      title={zoneLabel}
      initialLabel=""
      initialType={defaultType}
      initialSubtype={defaultSubtype}
      allowDelete={false}
      onConfirm={handleConfirm}
      onClose={onClose}
      screenX={screenX}
      screenY={screenY}
    />
  );
};

export default NodeAddPopup;
